import { useEffect, useState } from "react";
import { Trophy, Crown } from "lucide-react";
import { api, fmt } from "@/lib/api";

const medal = ["bg-[#D6AD62] text-[#111110]", "bg-[#C9C6BE] text-[#111110]", "bg-[#B9825A] text-white"];

export default function Leaderboard() {
  const [rows, setRows] = useState(null);
  useEffect(() => {
    const load = () => !document.hidden && api.get("/game/leaderboard").then((r) => setRows(r.data.rows)).catch(() => {});
    load();
    const t = setInterval(load, 60000);
    return () => clearInterval(t);
  }, []);
  if (!rows) return null;
  return (
    <div className="rounded-2xl bg-[#171715] text-[#F3EEE4] p-6 sm:p-7" data-testid="leaderboard">
      <div className="flex items-center justify-between gap-3">
        <p className="font-display font-bold text-lg flex items-center gap-2"><Trophy size={18} className="text-[#D6AD62]" /> Həftənin TOP-5 oyunçusu</p>
        <span className="text-[11px] text-[#a9a398]">Hər bazar ertəsi sıfırlanır</span>
      </div>
      {!rows.length ? (
        <p className="text-sm text-[#a9a398] mt-5" data-testid="leaderboard-empty">Bu həftə hələ heç kim oynamayıb — birinci sən ol!</p>
      ) : (
        <ol className="mt-5 space-y-2">
          {rows.map((r, i) => (
            <li key={i} className={`flex items-center gap-3 rounded-xl px-3 py-2.5 ${i === 0 ? "bg-[#D6AD62]/12 border border-[#D6AD62]/30" : "bg-white/[.04]"}`} data-testid={`leaderboard-row-${i}`}>
              <span className={`w-7 h-7 rounded-full flex items-center justify-center text-xs font-bold ${medal[i] || "bg-white/10"}`}>{i + 1}</span>
              <span className="flex-1 text-sm font-medium truncate">{r.name}</span>
              {r.won && <Crown size={14} className="text-[#D6AD62]" aria-label="Hədəfə çatıb" />}
              <span className="font-display font-bold text-[#F3D592]" data-testid={`leaderboard-score-${i}`}>{fmt(r.score)}</span>
            </li>
          ))}
        </ol>
      )}
      <p className="text-[11px] text-[#8b867c] mt-4">Ad yalnız hədiyyə üçün müraciət göndərən oyunçularda göstərilir (ad + soyadın ilk hərfi).</p>
    </div>
  );
}
